import { _js } from '@ifixit/localize';
import { Modal } from 'Shared/modal';
import { Auth } from 'Shared/auth';
import { Validation, Geo } from 'Shared/utils';
import { FormManager } from 'Shared/form_manager';
import { Recaptcha } from 'Shared/recaptcha';
import trackInPiwikAndGA from 'Shared/Analytics/CombinedGAPiwik';

let componentIds = {
   password: 'reg-password',
   email: 'reg-email',
   username: 'reg-username',
   communitySub: 'digest-emails',
   newsletterSub: 'news-emails',
};

const RegisterPanel = new Class({
   modalShowObserver: null,
   wasLinkClicked: false,
   showRegister: false,
   Implements: [Events],
   trackPopupExit: function (action) {
      return function () {
         this.wasLinkClicked = true;
         trackInPiwikAndGA({
            eventCategory: 'Join Popup Exit',
            eventAction: 'Join Popup Exit - ' + action,
         });
      };
   },
   addClickTracking: function () {
      document
         .querySelector('.privacy-policy-link')
         ?.addEvent('click', this.trackPopupExit('Privacy Policy Clicked'));
      document
         .querySelector('.terms-of-use-link')
         ?.addEvent('click', this.trackPopupExit('Terms Clicked'));
      document
         .getElementById('googleLogin')
         ?.addEvent('click', this.trackPopupExit('Google Signed-in'));
      document
         .getElementById('facebookLogin')
         ?.addEvent('click', this.trackPopupExit('Facebook Signed-in'));
   },
   removeClickHandlers: function () {
      let elements = [
         document.querySelector('.privacy-policy-link'),
         document.querySelector('.terms-of-use-link'),
         document.getElementById('googleLogin'),
         document.getElementById('facebookLogin'),
      ];
      elements.forEach(element => {
         element?.removeEvent('click', this.trackPopupExit);
      });
   },
   initialize: function () {
      let inviteData = $('inviteData');

      let formName = 'registerForm';
      let emailInput = $(componentIds.email);
      let formManager;

      if (inviteData) {
         emailInput.set('value', inviteData.get('data-email'));
      }

      addFormValidation();
      addModalSwitchWatcher.call(this);

      Geo.runEverywhereButEU(() => {
         $$('.js-community-yes-subscription').set('checked', true);
         $$('.js-newsletter-yes-subscription').set('checked', true);
         $$('.js-email-subscriptions').hide();
      });

      let UserLib = window.guide_constants.UserLib;
      let errorFields = {};
      errorFields[UserLib('ERR_PASSWORD_MISMATCH')] = componentIds.password;
      errorFields[UserLib('ERR_PASSWORD_INVALID')] = componentIds.password;
      errorFields[UserLib('ERR_USERNAME_INVALID')] = componentIds.username;
      errorFields[UserLib('ERR_UNIQUE_NAME_INVALID')] = componentIds.username;
      errorFields[UserLib('ERR_EMAIL_INVALID')] = componentIds.email;
      errorFields[UserLib('ERR_EMAIL_EXISTS')] = componentIds.email;
      errorFields[UserLib('ERR_EMAIL_VERIFICATION')] = componentIds.email;
      errorFields[UserLib('ERR_DISALLOWED')] = componentIds.email;
      errorFields[UserLib('ERR_USER_LIMIT')] = componentIds.email;
      errorFields[UserLib('ERR_TERMS_AGREE')] = componentIds.email;
      errorFields[UserLib('ERR_CAPTCHA_FAIL')] = 'form-captcha-register';

      function addModalSwitchWatcher() {
         const myDiv = document.getElementById('login');
         this.modalShowObserver = new MutationObserver(mutationsList => {
            for (const mutation of mutationsList) {
               if (
                  mutation.type === 'attributes' &&
                  mutation.attributeName === 'class' &&
                  ((mutation.target.className === 'showRegister' && !this.showRegister) ||
                     (mutation.target.className === 'showLogin' && this.showRegister))
               ) {
                  if (myDiv.getAttribute('class') === 'showRegister') {
                     this.showRegister = true;
                     this.addClickTracking();
                  } else if (myDiv.getAttribute('class') === 'showLogin') {
                     this.showRegister = false;
                     this.removeClickHandlers();
                  }
               }
            }
         });
         this.modalShowObserver.observe(myDiv, { attributes: true, attributeOldValue: true });
         if (myDiv.classList.contains('showRegister')) {
            this.showRegister = true;
            this.addClickTracking();
         }
      }

      function addFormValidation() {
         formManager = new FormManager(formName);

         formManager.setValidator(componentIds.username, el => {
            if (!Validation.username(el.value)) {
               formManager.error(el, App.registerMessages.username_invalid);
            }
         });

         formManager.addSubmitHandler(() => {
            let inviteCode = null;
            if (inviteData) {
               inviteCode = inviteData.get('data-code') || null;
            }

            const wantsEmails = function (name) {
               const selectedRadio = $E("[name='" + name + "']:checked");
               return selectedRadio && selectedRadio.value === 'yes';
            };

            const values = {
               login: emailInput.value,
               username: $(componentIds.username).value,
               password1: $(componentIds.password).value,
               inviteCode: inviteCode,
               wantsDigestEmails: wantsEmails(componentIds.communitySub),
               wantsNewsEmails: wantsEmails(componentIds.newsletterSub),
            };

            const recaptchaForm = $('form-captcha-register');
            let recaptchaKey = null;
            let recaptchaPlaceholder = null;
            if (recaptchaForm) {
               recaptchaKey = recaptchaForm.get('data-sitekey');
               recaptchaPlaceholder = document.querySelector('.js-captcha-container');
            }
            const registerPromise = Recaptcha.executeInvisible(
               recaptchaPlaceholder,
               recaptchaKey,
               'register'
            ).then(
               recaptchaResponse =>
                  new Promise((resolve, reject) => {
                     values.captchaResult = recaptchaResponse;
                     Auth.sendRegister(values, response => {
                        if (response.reason === 'email_verification_required') {
                           fireGlobal('login.success', response);
                           resolve();
                           window.location.href = '/Login/email_verification_sent';
                        } else if (response.loggedIn) {
                           if (App.which == 'ifixit') {
                              fbq('track', 'CompleteRegistration', { content_name: 'Account' });
                           }
                           fireGlobal('login.success', response);
                           resolve();
                        } else {
                           fireGlobal('login.failure', response);
                           formManager.showError(errorFields[response.reason], response.message);
                           reject();
                        }
                     });
                  })
            );

            LoadingIndicator.withPromise(registerPromise, {
               pendingMessage: _js('Registering your account...'),
               successMessage: _js('Registration successful'),
               failureMessage: _js('Registration unsuccessful'),
            });

            return false;
         });
      }
   },
   destroy: function () {
      let emailValue = $(componentIds.email).value;
      let usernameValue = $(componentIds.username).value;
      let passwordValue = $(componentIds.password).value ? true : false;

      let action = function (email, username, password) {
         if (email && username && password) {
            return 'Email & Display Name & Password Filled-out';
         }
         if (email && username) {
            return 'Email & Display Name Filled-out';
         }
         if (email) {
            return 'Email Filled-out';
         }
         return 'No Interaction';
      };

      if (!this.wasLinkClicked && this.showRegister) {
         trackInPiwikAndGA({
            eventCategory: 'Join Popup Exit',
            eventAction: `Join Popup Exit - ${action(emailValue, usernameValue, passwordValue)}`,
         });
      }

      this.removeClickHandlers.call(this);
      this.modalShowObserver.disconnect();
      this.modalShowObserver = null;
      this.showRegister = false;
   },
});

(function () {
   // Call outside of event listeners in case we aren't in a modal
   // (and the below events won't ever fire)
   onDomReady(initialize);
   let RegisterManager;

   Modal.addEvent('onLoginLoad', (element, options, data) => {
      App.registerMessages = data.registerMessages;
      initialize();
   });

   Modal.addEvent('onLoginUnload', () => {
      teardown();
   });

   function initialize() {
      if (RegisterManager) {
         return;
      }
      RegisterManager = new RegisterPanel();
   }

   function teardown() {
      if (RegisterManager) {
         RegisterManager.destroy();
         RegisterManager = null;
      }
   }
})();
